/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerDto } from '../../models/customer-dto';

export interface UpdateAssignmentSecurityExpert$Params {

/**
 * the customer id
 */
  customerId: number;

/**
 * the security expert
 */
  securityExpertId: number;
}

export function updateAssignmentSecurityExpert(http: HttpClient, rootUrl: string, params: UpdateAssignmentSecurityExpert$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerDto>> {
  const rb = new RequestBuilder(rootUrl, updateAssignmentSecurityExpert.PATH, 'patch');
  if (params) {
    rb.path('customerId', params.customerId, {});
    rb.query('securityExpertId', params.securityExpertId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerDto>;
    })
  );
}

updateAssignmentSecurityExpert.PATH = '/customers/{customerId}/security-expert';
